import React from 'react'
import { capabilitiesErrorAtom } from 'atoms/capabilities'
import { useAtomValue } from 'jotai'
import { useTranslation } from 'react-i18next'
import { EmptyState } from '@node-space/ui-components'
import { logSentryErrorAndGetEventId } from '@node-space/utils'
import { Lottie } from 'components/Animations/SimpleLottie'
import { RequestErrorStatusCard } from 'components/Errors/RequestErrorStatusCard'
import { ExternalLink } from 'components/ExternalLink/ExternalLink'
import { ExternalLinks } from 'constants/links'
import { customerModelAtom } from './atoms/customersAtoms'
import { CustomersList } from './CustomersList/CustomersList'

export const Customers = () => {
  const { t } = useTranslation()
  const customerModel = useAtomValue(customerModelAtom)

  const capabilitiesError = useAtomValue(capabilitiesErrorAtom)

  if (capabilitiesError) {
    const sentryEventId = logSentryErrorAndGetEventId(
      `Failed API request to /v1/capabilities/bulk with status ${capabilitiesError?.status}`,
      capabilitiesError
    )

    return (
      <RequestErrorStatusCard
        title={t('errorMessages.featureErrorTitle')}
        sentryEventId={sentryEventId}
      />
    )
  }

  if (customerModel) return <CustomersList customerModel={customerModel} />

  return (
    <EmptyState
      testId="customers-not-enabled"
      LottiePlayer={<Lottie src="permissions-denied" />}
      title={t('customers.notEnabledTitle')}
      description={
        <>
          <span>{t('customers.notEnabledDescription')}</span>
          <ExternalLink href={ExternalLinks.EMBEDDED_WALLETS_LEARN_MORE}>
            {t('learnMore')}
          </ExternalLink>
        </>
      }
    />
  )
}
